import { useState } from "react"
import { observer } from "mobx-react-lite"

import { ShowWhenTrue } from "@/components"
import { Card } from "@/components/card"
import { ClFarmRewards } from "@/domains/cl-farm/components/rewards/cl-farm-rewards"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { LockRewardsGroupedByNft } from "@/domains/lock-rewards/components/group-by-nft"
import { LockRewardsGroupedByToken } from "@/domains/lock-rewards/components/group-by-token"
import { FarmingRewards } from "@/domains/minimal-pool/components/rewards/farming-rewards"
import { FeeRewards } from "@/domains/minimal-pool/components/rewards/fee-rewards"
import { GroupVotingRewardsBy } from "@/domains/old-voting-rewards/components/voting-rewards-tabs"

import { BackToTop } from "./components/back-to-top"
import { DashboardSummary } from "./components/dashboard-summary"
import { ManualClEarnedFees } from "./components/manual-cl-earned-fees"

const DashboardPage = observer(() => {
  const [groupBy, setGroupBy] = useState<GroupVotingRewardsBy>("token")
  const title = "Dashboard"
  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title={title} subTitle="Your dashboard and earnings." />

      <div className="mb-12">
        <DashboardSummary />
      </div>

      <div className="flex flex-col gap-16">
        <div>
          <SectionHeading title="Voting Rewards" />
          <Card.Container className="text-t100">
            <ShowWhenTrue when={groupBy === "nft"}>
              <LockRewardsGroupedByNft groupBy={groupBy} setGroupBy={setGroupBy} />
            </ShowWhenTrue>
            <ShowWhenTrue when={groupBy === "token"}>
              <LockRewardsGroupedByToken groupBy={groupBy} setGroupBy={setGroupBy} />
            </ShowWhenTrue>
          </Card.Container>
        </div>

        <div>
          <SectionHeading title="Classic Pool Farming Rewards" />
          <FarmingRewards />
        </div>

        <div>
          <SectionHeading title="CL Farm Farming Rewards" />
          <ClFarmRewards />
        </div>

        <div>
          <SectionHeading title="CL Earned Fees" id="manual-cl-earned-fees" />
          <ManualClEarnedFees />
        </div>

        <div>
          <SectionHeading title="Earned Fees" />
          <FeeRewards />
        </div>
      </div>

      <div className="mt-8 flex justify-center">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-sm text-t200 underline transition-colors hover:text-t100"
        >
          Back to top
        </button>
      </div>

      <BackToTop />
    </PageContainer>
  )
})

const SectionHeading = ({ title, id }: { title: string; id?: string }) => {
  return (
    <h2 className="mb-2 text-xl font-bold text-t100" id={id ?? title.toLowerCase().replace(/\s+/g, "-")}>
      {title}
    </h2>
  )
}

export default DashboardPage
